import { Table, Typography } from "antd";
import PropTypes from "prop-types";

import InterventionsTable from "@/components/ListTable/InterventionsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import {
  getInterventionsTotalCost,
  INTERVENTIONS_FILTERS,
} from "@/entities/interventions";
import { ListProvider } from "@/modules/list";
import { TranslateCost } from "@/modules/translate";

import "./TabRecommendedInterventions.style.less";

const TabRecommendedInterventions = ({ interventionId }) => {
  return (
    <ListProvider
      endpoint="interventions"
      storageKey={STORAGE_KEYS.INTERVENTIONS_RECOMMENDATIONS}
      contextTabValue={TAB_KEYS.INTERVENTIONS_RECOMMENDATIONS}
      hiddenFilters={{
        [INTERVENTIONS_FILTERS.RECOMMENDED_FOR]: interventionId,
      }}
    >
      <InterventionsTable
        showLocationColumn
        showAssetColumn
        summary={(items) => (
          <Table.Summary.Row className="recommended-items-summary-row">
            <Table.Summary.Cell index={0} colSpan={8} />
            <Table.Summary.Cell align="right">
              <Typography.Text strong>
                <TranslateCost value={getInterventionsTotalCost(items)} />
              </Typography.Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell colSpan={5} />
          </Table.Summary.Row>
        )}
      />
    </ListProvider>
  );
};

TabRecommendedInterventions.propTypes = {
  interventionId: PropTypes.number.isRequired,
};

export default TabRecommendedInterventions;
